import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[m9ContentHost]',
})
export class ContentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
